import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DetailsComponent } from './details/details.component';
import { InputComponent } from './input/input.component';

const routes: Routes = [
    { path: '', component: InputComponent },
    { path: ':id', component: DetailsComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class GiftCardBalanceRoutingModule {}
